import { TransformWithLVS } from './TransformWithLVS';
export function StringToArray(options = {}, transformOptions) {
    return TransformWithLVS(({ value }) => {
        const { separator = ',' } = options;
        if (typeof value === 'string') {
            return value.split(separator);
        }
        return value;
    }, { ...transformOptions, toClassOnly: true, toPlainOnly: false });
}
//# sourceMappingURL=StringToArray.js.map